import { Notification as BaseNofitification } from 'baseui/notification'
import React, { FC, forwardRef } from 'react'
import { NotificationType } from '../../types/notification.enum'

// because baseui does not provide a way to change the close icon, we have to create our own
const CloseIcon = forwardRef((props, ref) => <i className="wemolo-cross cursor-pointer" {...props} />)
CloseIcon.displayName = 'CloseIcon'

interface Props {
    children: React.ReactNode
    type: NotificationType
    onClose?: () => void
}

const parseNotificationType = (type: NotificationType) => {
    switch (type) {
        case NotificationType.NEGATIVE:
            return 'negative'
        case NotificationType.POSITIVE:
            return 'positive'
        case NotificationType.INFO:
            return 'info'
        case NotificationType.WARNING:
            return 'warning'
        default:
            return 'negative'
    }
}

const Notification: FC<Props> = ({ children, type, onClose }) => {
    return (
        <BaseNofitification
            closeable
            onClose={onClose}
            autoHideDuration={type === 'positive' ? 3000 : 30000}
            kind={parseNotificationType(type)}
            overrides={{
                Body: {
                    style: ({ $theme }) => ({
                        padding: '2rem',
                        width: 'auto',
                        position: 'absolute',
                        top: '4rem',
                        left: 0,
                        right: 0,
                        flexDirection: 'column-reverse',
                        gap: '1rem',
                        fontWeight: 400,
                        fontSize: '1.4rem',
                        lineHeight: '2.4rem',

                        [$theme.mediaQuery.large]: {
                            top: '8rem',
                            left: '50%',
                            transform: 'translateX(-50%)'
                        }
                    })
                },
                CloseIcon: {
                    component: CloseIcon
                }
            }}
        >
            {children}
        </BaseNofitification>
    )
}

export default Notification
